import { AudienceDefinition } from "@models/audienceDefinition.model";

export class AudienceDefinitionSerializer {
  deserialize(data: any): AudienceDefinition {
    const obj = new AudienceDefinition();
    obj.id = data.id;
    obj.name = data.name;
    obj.rules = data.rules ?? {};
    obj.audience_preset = data.audience_preset ?? null;
    obj.launch_id = data.launch_id ?? null;
    obj.ad_group_id = data.ad_group_id ?? null;
    obj.total_members = data.total_members ?? 0;
    obj.total_active = data.total_active ?? 0;
    // "being shown ads" = is_serving_ads AND NOT is_control. Falls back to total_active
    // until the backend ships the dedicated count.
    obj.total_targetable = data.total_targetable ?? data.targetable ?? data.total_active ?? 0;
    obj.total_converted = data.total_converted ?? 0;
    // The Active · Channel holdout tiles (MPN-2078). An older server sends none.
    obj.channel_holdouts = data.channel_holdouts ?? [];
    return obj;
  }

  deserializeList(data: any[]): AudienceDefinition[] {
    return data.map((item) => this.deserialize(item));
  }
}
